module.exports = __webpack_public_path__ + "img/undraw_developer_activity_bv83.59389695.svg";